var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"surf-detail-header-affix",class:[_vm.offset !== 0 && 'with-offset'],style:({ top: `${_setup.realOffset}px` })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }